import type {
  ThemeFacetView,
  ThemeSearchRequest,
  ThemeSortView,
  WThemeGroupSearchResultsView,
  WThemeListingSearchResultsView,
} from '@zola/svc-web-api-ts-client';
import { PLPFilterOptions } from '../helpers';

// Action Types
export const RECEIVE_THEME_SEARCH = 'websitePlp/receiveThemeSearch';
export const UPDATE_THEME_FILTERS = 'websitePlp/updateThemeFilters';
export const UPDATE_THEME_SORT = 'websitePlp/updateThemeSort';
export const REQUEST_THEMES = 'websitePlp/requestThemes';
export const CLEAR_THEMES = 'websitePlp/clearThemes';

export type ReceiveThemeSearchAction = {
  type: typeof RECEIVE_THEME_SEARCH;
  payload: {
    busy: false;
    facets: ThemeFacetView[];
    sorts: ThemeSortView[];
    displayable_total?: number;
    theme_groups: WThemeGroupSearchResultsView[];
    hasMore: boolean;
  };
};

export type UpdateThemeFiltersAction = {
  type: typeof UPDATE_THEME_FILTERS;
  payload: {
    filters: PLPFilterOptions;
  };
};

export type UpdateThemeSortAction = {
  type: typeof UPDATE_THEME_SORT;
  payload: {
    applied_sort: ThemeSearchRequest.SortKeyEnum;
  };
};

export type RequestThemesAction = {
  type: typeof REQUEST_THEMES;
};

export type ClearThemesAction = {
  type: typeof CLEAR_THEMES;
};

// Actions
export const receiveThemeSearch = (
  searchResult: WThemeListingSearchResultsView
): ReceiveThemeSearchAction => {
  const { displayable_total, facets, limit, sorts, theme_groups, total } = searchResult;
  return {
    type: RECEIVE_THEME_SEARCH,
    payload: {
      busy: false,
      displayable_total,
      facets,
      hasMore: total >= limit,
      sorts,
      theme_groups,
    },
  };
};

export const updateFilters = (newFilters: PLPFilterOptions): UpdateThemeFiltersAction => ({
  type: UPDATE_THEME_FILTERS,
  payload: {
    filters: newFilters,
  },
});

export const updateSort = (sortKey: ThemeSearchRequest.SortKeyEnum): UpdateThemeSortAction => ({
  type: UPDATE_THEME_SORT,
  payload: {
    applied_sort: sortKey,
  },
});

export const requestThemes = (): RequestThemesAction => ({
  type: REQUEST_THEMES,
});

export const clearThemes = (): ClearThemesAction => ({
  type: CLEAR_THEMES,
});

export type WebsitePlpActions =
  | ReceiveThemeSearchAction
  | UpdateThemeFiltersAction
  | RequestThemesAction
  | ClearThemesAction
  | UpdateThemeSortAction;

export const websitePlpActions = {
  receiveThemeSearch,
  updateFilters,
  clearThemes,
};
